import {SET_ENV_VARIABLES, GET_ENV_VARIABLES, CLEAR_ENV_VARIABLES} from "./actionTypes";

export const getEnvironmentVariables = (org) => {
    return {
        type: GET_ENV_VARIABLES,
        payload: { org }
    };
};

export const setEnvironmentVariables = ({ vars = [], error }) => {
    return {
        type: SET_ENV_VARIABLES,
        payload: { vars, error }
    };
};

export const clearEnvironmentVariables = () => {
    return {
        type: CLEAR_ENV_VARIABLES,
        payload: {}
    };
};
